//
//
//
//
//
//
//
//
//
//
//

import common from '@/tools/common'
export default {
  name : 'Marquee',
  props: ['lists'], // 父组件传入数据， 数组形式 [ "连雨不知春去","一晴方觉夏深"]
  data () {
    return {
      text: '',
      dtokens: '',
      utoken: ''
    }
  },
  methods: {
    move () {
      // 获取文字text 的计算后宽度  （由于overflow的存在，直接获取不到，需要独立的node计算）
      let width = this.$refs.node.getBoundingClientRect().width
      this.$refs.copy.innerText = this.text // 文字副本填充
      let distance = 0 // 位移距离
      // 设置位移
      setInterval(() => {
        distance = distance - 1
        // 如果位移超过文字宽度，则回到起点
        if (-distance >= width) {
          distance = 12
        }
        this.$refs.box.style.transform = 'translateX(' + distance + 'px)'
      }, 20)
    },
    gotoDownPage () {
      this.dtokens = common.getcustomsSession('dtoken')
      this.utoken = common.getcustomsSession('utoken')
      console.log(this.dtokens)
      console.log(this.utoken)
      this.$router.push({name: 'DownloadNoticeFiles', params: {down_token: this.dtokens, user_token: this.utoken}})
    }
  },
  // 把父组件传入的arr转化成字符串
  mounted: function () {
    for (let i = 0; i < this.lists.length; i++) {
      this.text += ' ' + this.lists[i] == null ? '' : this.lists[i]
    }
  },
  // 更新的时候运动
  updated: function () {
    this.move()
  }
}



// WEBPACK FOOTER //
// ./src/components/common/my-marquee.vue